/* "Fits your vehicle": green tick on product cards for the customer's saved car,
   fitting parts moved to the top of collection and search lists, and a fit note on product pages. */
(function () {
  'use strict';
  var car = null;
  try { car = JSON.parse(localStorage.getItem('be-vehicle') || 'null'); } catch (e) { car = null; }
  if (!car || !car.tokens || !car.tokens.length) { return; }
  var toks = car.tokens.map(function (t) { return String(t).toLowerCase(); });
  var label = car.label || 'your car';

  var fits = function (el) {
    var tags = (el.getAttribute('data-be-tags') || '').split(',');
    for (var i = 0; i < tags.length; i++) { if (toks.indexOf(tags[i].trim()) !== -1) { return true; } }
    return false;
  };
  var mark = function (root) {
    (root || document).querySelectorAll('[data-be-tags]').forEach(function (card) {
      if (card.getAttribute('data-be-fit-checked')) { return; }
      card.setAttribute('data-be-fit-checked', '1');
      if (fits(card)) {
        card.classList.add('is-fit');
        var b = card.querySelector('[data-be-fitbadge]');
        if (b) { b.hidden = false; b.title = 'Fits your ' + label; }
      }
    });
  };
  mark();
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; mark(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Product page note ---------- */
  if (document.body.classList.contains('template-product')) {
    var info = document.querySelector('.be-info h1');
    if (info) {
      fetch(window.location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.tags) { return; }
          var ok = p.tags.some(function (t) { return toks.indexOf(String(t).toLowerCase()) !== -1; });
          var n = document.createElement('div');
          n.className = 'be-fitnote ' + (ok ? 'is-fit' : 'is-unknown');
          n.textContent = ok ? 'Fits your ' + label : 'Not listed for your ' + label + '. Contact us to check fitment.';
          info.parentNode.insertBefore(n, info.nextSibling);
        })
        .catch(function () {});
    }
    return;
  }

  /* ---------- Fitting parts first on collection and search lists ---------- */
  var coll = document.querySelector('[data-be-coll]');
  var isSearch = document.body.classList.contains('template-search');
  var grid = coll ? coll.querySelector('.be-grid') : (isSearch ? document.querySelector('main .be-grid') : null);
  if (!grid) { return; }
  var params = new URLSearchParams(window.location.search);
  var page = parseInt(params.get('page') || '1', 10) || 1;
  var urls = [], filterHere = false;

  if (coll) {
    var base = coll.getAttribute('data-base') || '/collections/all';
    var rest = window.location.pathname.indexOf(base) === 0 ? window.location.pathname.slice(base.length).replace(/^\/+|\/+$/g, '') : '';
    var cur = rest ? decodeURIComponent(rest).toLowerCase().split('+').filter(Boolean) : [];
    if (toks.some(function (t) { return cur.indexOf(t) !== -1; })) { return; }
    var p = new URLSearchParams(params.toString());
    p.delete('page');
    p.set('view', 'fits');
    toks.forEach(function (t) {
      urls.push(base + '/' + cur.concat(t).map(encodeURIComponent).join('+') + '?' + p.toString());
    });
  } else {
    var q = params.get('q') || '';
    if (!q || /^\s*tag:/i.test(q)) { return; }
    var p2 = new URLSearchParams(params.toString());
    p2.delete('page');
    p2.set('view', 'fits');
    p2.set('type', 'product');
    urls.push('/search?' + p2.toString());
    filterHere = true;
  }

  Promise.all(urls.map(function (u) {
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  })).then(function (pages) {
    var seen = {}, fitCards = [];
    pages.forEach(function (html) {
      if (!html) { return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-be-tags]').forEach(function (c) {
        var id = c.getAttribute('data-be-id');
        if (!id || seen[id]) { return; }
        if (filterHere && !fits(c)) { return; }
        seen[id] = true;
        fitCards.push(c);
      });
    });
    if (!fitCards.length) { return; }
    /* Fitting parts are shown together on page 1, so take them out of the normal list on every page. */
    grid.querySelectorAll('[data-be-tags]').forEach(function (c) {
      if (seen[c.getAttribute('data-be-id')]) { c.remove(); }
    });
    if (page !== 1) { return; }
    var head = function (text, cls) {
      var h = document.createElement('div');
      h.className = 'be-fitgroup' + (cls ? ' ' + cls : '');
      h.textContent = text;
      return h;
    };
    var first = grid.firstElementChild;
    if (first) { grid.insertBefore(head('Other parts'), first); first = grid.firstElementChild; }
    grid.insertBefore(head(fitCards.length + (fitCards.length === 1 ? ' part fits' : ' parts fit') + ' your ' + label, 'is-fit'), first);
    fitCards.forEach(function (c) {
      c.removeAttribute('data-be-fit-checked');
      grid.insertBefore(document.importNode(c, true), first);
    });
    mark(grid);
  });
})();
